import { compose, mdsWidget } from 'dojo/_base/declare';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import template from './Icon.html?raw';

class Icon extends compose(_WidgetBaseSP, _TemplatedMixin) {
    [key: string]: any;
    templateString: any = template;
    onChange() { }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    _onClick_Tooltip(evt: any) {
        this.emit("tooltip_click");
        //evt.stopPropagation();
    }

    clear() {
        (this.tooltip as any).innerHTML = "";
    }

    unSelect() {

    }
    getSelectedValues() {
        return {
            tooltip: (this.tooltip as any).innerHTML
        };
    }

    show() {
        domStyle.set(this.icon, "display", "inline");
    }

    hide() {
        domStyle.set(this.icon, "display", "none");
    }
}
Icon.prototype.declaredClass = 'more.Controls.Icon';

export default mdsWidget(Icon);
